export enum FULL_OFFERT_MENU_TYPES {
   WALLET = 'WALLET',
   INFO = 'INFO'
}

export interface IFullOffertInfoMenuProps {
   isNavbarWalletMenu?: boolean;
   className?: string;
   menuType: FULL_OFFERT_MENU_TYPES;
   workflowId?: number | null;
   isLoading?: boolean;
}